import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CompleteEduRegistrationPage } from '@/pages/authentication/ui/CompleteEduRegistrationPage'

const completeEduRegistrationSearchSchema = z.object({
  token: z.string().catch(''),
})

export const Route = createFileRoute('/complete-edu-registration')({
  validateSearch: completeEduRegistrationSearchSchema,
  component: CompleteEduRegistrationPage,
})
